import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

import { Rate, Select } from 'antd';
import { capitalizeFirstLetter, checkUndefine } from '../../../../../../helpers/functions';
import DEFINE, { HOMESTAY, UPLOAD_DIRECTORY, DETAIL_ACTIONS } from '../../../../../../constants/Define';
import {
    FormWrapperItem,
    FormWrapperInputComponent,
} from "../../../../common/component/Index";
import Input from "../../../../common/component/Input";
import TextArea from "../../../../common/component/TextArea";
import Wrapper from "../../../../common/component/Wrapper";
import UploadImage from "../../../../common/component/UploadImage";
import RichTextEditor, { ClassicEditor } from '../../../../common/component/RichTextEditor';
import { cloneDeep, get } from "lodash";

import './styles.less';
import Item from 'antd/lib/list/Item';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';

class BasicInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            amenities: [],
            dataAmenity: []
        };
        this.descriptionInputRef = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.amenities !== state.amenities) {
            const newAmenities = props.amenities.filter(item => item.isActive)
            const newHomestayAmenity = props.homestay.amenity.filter(item => newAmenities.find(i => i.id === item))
            return {
                amenities: newAmenities,
                dataAmenity: newHomestayAmenity
            };
        }
        return null;
    }

    onChangeImagesOrder = (e) => {
        const media = cloneDeep(this.props.homestay?.media || []);
        const newMedia = media.map(x=>{
            return {
                ...x,
                order: e.findIndex(y=>y.endsWith(x.url))
            };
        }).sort((a, b) => a.order - b.order);
        this.props.onChange('media', newMedia);
    }

    render() {
        const { t, homestay, uploading, disabled, validation, action } = this.props;
        const { amenities, dataAmenity } = this.state;
        return (
            <Wrapper className="basic-info-section">
                <h3 className={`ml-3`}>{t('item.homestay.basicInfo')}</h3>
                <FormWrapperItem>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.images`)}
                        >
                            <UploadImage
                                multiple={true}
                                loading={uploading}
                                thumbnailSize={120}
                                buttonSize={120}
                                disabledUpload={disabled}
                                disabledRemove={disabled}
                                uploadText={t('item.homestay.uploadFile')}
                                loadingText={t('item.homestay.uploading')}
                                onChange={this.props.onUploadImage}
                                onRemoveThumbnail={this.props.onRemoveImage}
                                thumbnails={this.getThumbSources(homestay.media)}
                                allowChangeOrder={true}
                                onChangeOrder={this.onChangeImagesOrder}/>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={homestay.name}
                            validation={validation.name}
                            labelTitle={t(`item.homestay.name`)}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`name`} onChange={(e) => this.props.onChange('name', e.target.value)}
                                value={checkUndefine(homestay.name)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={homestay.code}
                            validation={validation.code}
                            labelTitle={t(`item.homestay.code`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`code`} onChange={(e) => this.props.onChange('code', e.target.value)}
                                value={checkUndefine(homestay.code)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={homestay.star}
                            validation={validation.star}
                            labelTitle={t(`item.homestay.star`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Wrapper>
                                <Rate value={homestay.star} onChange={(value) => this.props.onChange('star', value)} />
                            </Wrapper>
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.tripAdvisorLocationId`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`tripAdvisorLocationId`} onChange={(e) => this.props.onChange('tripAdvisorLocationId', e.target.value)}
                                value={checkUndefine(homestay.tripAdvisorLocationId)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    {/* <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.types`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Select className="select-types"
                                showArrow
                                mode="multiple"
                                placeholder={t(`item.homestay.selectTypes`)}
                                value={homestay.types}
                                onChange={types => this.props.onChange('types', types)}
                                style={{ width: '100%' }}
                            >
                                {Object.keys(HOMESTAY.TYPE).map(type => (
                                    <Select.Option key={HOMESTAY.TYPE[type]} value={HOMESTAY.TYPE[type]}>
                                        {t(`item.homestay.${HOMESTAY.TYPE[type]}`)}
                                    </Select.Option>
                                ))}
                            </Select>
                        </FormWrapperInputComponent>
                    </Wrapper> */}
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.hotline`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control text-right`}
                                name={`hotline`} onChange={this.onPhoneChange}
                                value={homestay.hotline} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.review`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control text-right`}
                                name={`review`} onChange={(e) => this.props.onChange('review', e.target.value)}
                                value={homestay.review} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.thumbnailTag`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`thumbnailTag`} onChange={(e) => this.props.onChange('thumbnailTag', e.target.value)}
                                value={homestay.thumbnailTag} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-6">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.urlSlug`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <Input placeholder="" type={`text`}
                                className={`form-control`}
                                name={`urlSlug`} onChange={(e) => this.props.onChange('urlSlug', e.target.value)}
                                value={homestay.urlSlug} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.shortDescription`)}
                        >
                            <TextArea
                                className="form-control" name="shortDescription"
                                onChange={e => this.props.onChange('shortDescription', e.target.value.trimLeft())}
                                value={homestay.shortDescription} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.description`)}
                        >
                            <RichTextEditor
                                ref={this.descriptionInputRef}
                                disabled={disabled}
                                editor={ClassicEditor}
                                data={homestay.description}
                                config={{ uploadDirectory: UPLOAD_DIRECTORY.HOMESTAY }}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    return this.props.onChange("description", data)
                                }}
                            />
                        </FormWrapperInputComponent>
                    </Wrapper>
                    <Wrapper className="col-md-12">
                        <FormWrapperInputComponent
                            labelTitle={t(`item.homestay.amenity`)}
                            visible={action !== DETAIL_ACTIONS.TRANSLATE}
                        >
                            <AntSelect className="select-types"
                                showArrow
                                mode="multiple"
                                placeholder={capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.homestay.amenity")).toLowerCase())}
                                value={dataAmenity}
                                onChange={amenity => this.props.onChange('amenity', amenity)}
                                style={{ width: '100%' }}
                            >
                                {(amenities || []).map(amenity => (
                                    <AntOption key={amenity.id} value={amenity.id}>
                                        {amenity.name}
                                    </AntOption>
                                ))}
                            </AntSelect>
                        </FormWrapperInputComponent>
                    </Wrapper>
                </FormWrapperItem>
            </Wrapper>
        );
    }

    getThumbSources(thumbs) {
        return thumbs.filter(t => t && Object.keys(t).length > 0).map(t => t.url && t.url.startsWith('http') ? t.url : `${DEFINE.GENERAL.CDN_IMG_DEFAULT}${t.url}`)
    }

    onPhoneChange = (event) => {
        const phoneStr = event.target.value;
        const regex = /[0-9 .\-\(\)]+$/;
        if (!phoneStr || regex.test(phoneStr))
            this.props.onChange('hotline', phoneStr)
    }

    setDescription = (description) => {
        if (this.descriptionInputRef.current && get(this.descriptionInputRef.current, 'editor.setData') && description) {
            return this.descriptionInputRef.current.editor.setData(description)
        }
    }

}

BasicInfo.defaultProps = {
    onChange: () => { },
    action: DETAIL_ACTIONS.CREATE,
}

export default withTranslation(undefined, { withRef: true })(BasicInfo);
